import { TableRow } from '@common-fe/common-fe';
import styled from 'styled-components';

export const StyledTableRow = styled(TableRow)`
  background-color: ${({ theme }) => theme.colors.accentContainer} !important;
`;
